import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddOrderPromotionInput = {
  code: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type AddressComponentInputSchema = {
  long_name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddressInputSchema = {
  address_components?: InputMaybe<Array<AddressComponentInputSchema>>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthProvider {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Phone = 'PHONE'
}

export type AuthenticateUserInput = {
  email: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  placementId?: InputMaybe<Scalars['String']['input']>;
  provider: AuthProvider;
};

export type Chptr = {
  __typename?: 'Chptr';
  about?: Maybe<Scalars['String']['output']>;
  bornAt: DateParts;
  contributions: ContributionConnection;
  contributors: Array<ChptrContributor>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  events: Array<Event>;
  featuredContributions: Array<Contribution>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isFeatured: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  linkTitle?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  me?: Maybe<ChptrUserOwnerUnion>;
  notice?: Maybe<Scalars['Boolean']['output']>;
  owner: ChptrOwner;
  passedAt: DateParts;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']['output']>;
  reps: Array<ChptrRep>;
  status: Scalars['String']['output'];
  tags: Array<ChptrTag>;
  type: ChptrType;
  updatedAt: Scalars['DateTime']['output'];
  users: Array<ChptrUser>;
  videoInterest?: Maybe<Scalars['Boolean']['output']>;
  visibility: ChptrVisibility;
  webPictureUrl?: Maybe<Scalars['String']['output']>;
};


export type ChptrContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mediaType?: InputMaybe<ContributionMediaType>;
  orderBy?: InputMaybe<ContributionOrderByInput>;
};


export type ChptrContributorsArgs = {
  role?: InputMaybe<ChptrUserRole>;
};


export type ChptrUsersArgs = {
  role?: InputMaybe<ChptrUserRole>;
};

export type ChptrConnection = {
  __typename?: 'ChptrConnection';
  edges: Array<ChptrNode>;
  pageInfo: ConnectionPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChptrContributor = {
  __typename?: 'ChptrContributor';
  chptr: Chptr;
  id: Scalars['String']['output'];
  relationship?: Maybe<ChptrUserRelationship>;
  role?: Maybe<ChptrUserRole>;
  user: User;
};

export type ChptrInvoiceIntent = {
  __typename?: 'ChptrInvoiceIntent';
  clientSecret: Scalars['String']['output'];
  productPriceId: Scalars['String']['output'];
};

export type ChptrNode = {
  __typename?: 'ChptrNode';
  cursor: Scalars['String']['output'];
  node: Chptr;
};

export type ChptrOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  passedAtDay?: InputMaybe<SortOrder>;
  passedAtMonth?: InputMaybe<SortOrder>;
  passedAtYear?: InputMaybe<SortOrder>;
  randomized?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ChptrOwner = {
  __typename?: 'ChptrOwner';
  chptr: Chptr;
  relationship?: Maybe<ChptrUserRelationship>;
  role: ChptrUserRole;
  user: User;
};

export type ChptrRelationship = {
  __typename?: 'ChptrRelationship';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  relationshipId?: Maybe<Scalars['String']['output']>;
};

export type ChptrRep = {
  __typename?: 'ChptrRep';
  chptr: Chptr;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ChptrRepsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ChptrTag = {
  __typename?: 'ChptrTag';
  id: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export enum ChptrType {
  Celebration = 'CELEBRATION',
  Memorial = 'MEMORIAL',
  Wedding = 'WEDDING'
}

export type ChptrUser = {
  __typename?: 'ChptrUser';
  chptr: Chptr;
  id: Scalars['String']['output'];
  relationship?: Maybe<ChptrUserRelationship>;
  role: ChptrUserRole;
  user: User;
};

export type ChptrUserOwnerUnion = ChptrOwner | ChptrUser;

export type ChptrUserParentRelationship = {
  __typename?: 'ChptrUserParentRelationship';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ChptrUserRelationship = {
  __typename?: 'ChptrUserRelationship';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ChptrUserParentRelationship>;
};

export enum ChptrUserRole {
  Author = 'AUTHOR',
  Editor = 'EDITOR',
  Pending = 'PENDING',
  Publisher = 'PUBLISHER'
}

export enum ChptrVisibility {
  GlobalPublic = 'GLOBAL_PUBLIC',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Comment = {
  __typename?: 'Comment';
  contribution: Contribution;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: CommentStatus;
  text: Scalars['String']['output'];
  user: User;
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  edges: Array<CommentNode>;
  pageInfo: ConnectionPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CommentNode = {
  __typename?: 'CommentNode';
  cursor: Scalars['String']['output'];
  node: Comment;
};

export enum CommentStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ConnectionPageInfo = {
  __typename?: 'ConnectionPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Contribution = {
  __typename?: 'Contribution';
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  blurHash?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  chptr: Chptr;
  comments: Array<Comment>;
  commentsV2: CommentConnection;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  liked: Scalars['Boolean']['output'];
  mediaType: ContributionMediaType;
  muxUploadId?: Maybe<Scalars['String']['output']>;
  ordinal?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: ContributionType;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  user: User;
};


export type ContributionCommentsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ContributionConnection = {
  __typename?: 'ContributionConnection';
  edges: Array<ContributionNode>;
  pageInfo: ConnectionPageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ContributionMediaType {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type ContributionNode = {
  __typename?: 'ContributionNode';
  cursor: Scalars['String']['output'];
  node: Contribution;
};

export type ContributionOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum ContributionStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum ContributionType {
  Memory = 'MEMORY',
  Moment = 'MOMENT'
}

export type ContributionUpload = {
  __typename?: 'ContributionUpload';
  chptr: Chptr;
  id: Scalars['String']['output'];
  mediaType: ContributionMediaType;
  title?: Maybe<Scalars['String']['output']>;
  type: ContributionType;
  uploadId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
  user: User;
};

export type CreateAudioVideoContributionUploadInput = {
  chptrId: Scalars['String']['input'];
  placementId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ContributionType;
};

export type CreateChptrInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  bornAt?: InputMaybe<DatePartsInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  passedAt?: InputMaybe<DatePartsInput>;
  picture?: InputMaybe<Scalars['Upload']['input']>;
  placementId?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
  reps?: InputMaybe<Array<ChptrRepsInput>>;
  source?: InputMaybe<Scalars['String']['input']>;
  visibility: ChptrVisibility;
};

export type CreateChptrInvoiceIntentInput = {
  chptrId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productPriceId: Scalars['String']['input'];
};

export type CreateChptrRepInput = {
  chptrId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommentInput = {
  contributionId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CreateEventInput = {
  chptrId: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationAddress?: InputMaybe<AddressInputSchema>;
  locationPlaceId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
  visitEndAt?: InputMaybe<Scalars['String']['input']>;
  visitLink?: InputMaybe<Scalars['String']['input']>;
  visitLocation?: InputMaybe<Scalars['String']['input']>;
  visitLocationAddress?: InputMaybe<AddressInputSchema>;
  visitLocationPlaceId?: InputMaybe<Scalars['String']['input']>;
  visitStartAt?: InputMaybe<Scalars['String']['input']>;
};

export type CreateImageContributionInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  chptrId: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
  placementId?: InputMaybe<Scalars['String']['input']>;
  type: ContributionType;
};

export type CreateOrderInput = {
  chptrId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};

export type CreatePaymentIntentInput = {
  phoneNumber: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};

export type CreateTextContributionInput = {
  caption: Scalars['String']['input'];
  chptrId: Scalars['String']['input'];
  placementId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ContributionType;
};

export type DateParts = {
  __typename?: 'DateParts';
  day?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type DatePartsInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type DeactivateUserInput = {
  id: Scalars['String']['input'];
};

export type Event = {
  __typename?: 'Event';
  chptr?: Maybe<Chptr>;
  chptrId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationAddress?: Maybe<Scalars['JSON']['output']>;
  locationPlaceId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Property>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  visitEndAt?: Maybe<Scalars['DateTime']['output']>;
  visitLink?: Maybe<Scalars['String']['output']>;
  visitLocation?: Maybe<Scalars['String']['output']>;
  visitLocationAddress?: Maybe<Scalars['JSON']['output']>;
  visitLocationPlaceId?: Maybe<Scalars['String']['output']>;
  visitStartAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventConnection = {
  __typename?: 'EventConnection';
  edges: Array<EventNode>;
  pageInfo: ConnectionPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventNode = {
  __typename?: 'EventNode';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type EventOrderByInput = {
  startAt?: InputMaybe<SortOrder>;
};

export type ForgotUserPasswordInput = {
  email: Scalars['String']['input'];
};

export type LeaveChptrInput = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type LikeUnlikeContributionInput = {
  id: Scalars['String']['input'];
  liked: Scalars['Boolean']['input'];
};

export type LoginUserInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _: Scalars['String']['output'];
  addOrderPromotion: Order;
  approveChptrInvite: ChptrUser;
  authenticateUser: UserAuthentication;
  createAudioContributionUploads: Array<ContributionUpload>;
  createChptr: Chptr;
  createChptrInvoiceIntent: ChptrInvoiceIntent;
  createChptrRep: ChptrRep;
  createChptrReviewVideo: Result;
  createComment: Comment;
  createCommentV2: Comment;
  createEvent: Event;
  createImageContributions: Array<Contribution>;
  createOrder: Order;
  createPaymentIntent: PaymentIntent;
  createTextContributions: Array<Contribution>;
  createVideoContributionUploads: Array<ContributionUpload>;
  deactivateUser: Result;
  deleteChptr: Chptr;
  deleteChptrRep: Remove;
  deleteComment: Remove;
  deleteContribution: Remove;
  denyChptrInvite: Result;
  forgotUserPassword: Result;
  joinChptr: ChptrUser;
  leaveChptr: Result;
  likeUnlikeContribution: Contribution;
  loginUser: UserAuthentication;
  registerContributionUser: UserAuthentication;
  registerUser: UserAuthentication;
  removeOrderPromotion: Order;
  reportContribution: Result;
  resetUserPassword: Result;
  sendChptrInvites: Result;
  updateChptr: Chptr;
  updateChptrRep: ChptrRep;
  updateContribution: Contribution;
  updateEvent: Event;
  updateOrder: Order;
  updatePaymentIntent: PaymentIntent;
  updateUser: User;
};


export type MutationAddOrderPromotionArgs = {
  input: AddOrderPromotionInput;
};


export type MutationApproveChptrInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAuthenticateUserArgs = {
  input: AuthenticateUserInput;
};


export type MutationCreateAudioContributionUploadsArgs = {
  input: Array<CreateAudioVideoContributionUploadInput>;
};


export type MutationCreateChptrArgs = {
  input: CreateChptrInput;
};


export type MutationCreateChptrInvoiceIntentArgs = {
  input: CreateChptrInvoiceIntentInput;
};


export type MutationCreateChptrRepArgs = {
  input: CreateChptrRepInput;
};


export type MutationCreateChptrReviewVideoArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCommentV2Args = {
  input: CreateCommentInput;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateImageContributionsArgs = {
  input: Array<CreateImageContributionInput>;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreatePaymentIntentArgs = {
  input: CreatePaymentIntentInput;
};


export type MutationCreateTextContributionsArgs = {
  input: Array<CreateTextContributionInput>;
};


export type MutationCreateVideoContributionUploadsArgs = {
  input: Array<CreateAudioVideoContributionUploadInput>;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};


export type MutationDeleteChptrArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteChptrRepArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteContributionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDenyChptrInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationForgotUserPasswordArgs = {
  input: ForgotUserPasswordInput;
};


export type MutationJoinChptrArgs = {
  id: Scalars['String']['input'];
};


export type MutationLeaveChptrArgs = {
  input: LeaveChptrInput;
};


export type MutationLikeUnlikeContributionArgs = {
  input: LikeUnlikeContributionInput;
};


export type MutationLoginUserArgs = {
  input: LoginUserInput;
};


export type MutationRegisterContributionUserArgs = {
  input: RegisterContributionUserInput;
};


export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
};


export type MutationRemoveOrderPromotionArgs = {
  input: RemoveOrderPromotionInput;
};


export type MutationReportContributionArgs = {
  input: ReportContributionInput;
};


export type MutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type MutationSendChptrInvitesArgs = {
  input: SendChptrInvitesInput;
};


export type MutationUpdateChptrArgs = {
  input: UpdateChptrInput;
};


export type MutationUpdateChptrRepArgs = {
  input: UpdateChptrRepInput;
};


export type MutationUpdateContributionArgs = {
  input: UpdateContributionInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdatePaymentIntentArgs = {
  input: UpdatePaymentIntentInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type Notification = {
  __typename?: 'Notification';
  action: Scalars['String']['output'];
  chptr: Chptr;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  initiator: User;
  message: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  amount: Scalars['Int']['output'];
  chptr: Chptr;
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  products: Array<Product>;
  promotedAmount: Scalars['Int']['output'];
  promotions: Array<Promotion>;
  status: OrderStatus;
  stripeKey: Scalars['String']['output'];
};

export enum OrderStatus {
  Canceled = 'CANCELED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type Partner = {
  __typename?: 'Partner';
  additionalTermsUrl?: Maybe<Scalars['String']['output']>;
  chptrs: ChptrConnection;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  promotions: Array<Promotion>;
  properties: Array<PartnerProperty>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PartnerChptrsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerPlacement = {
  __typename?: 'PartnerPlacement';
  chptrs: ChptrConnection;
  contributions: ContributionConnection;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  property: PartnerProperty;
  updatedAt: Scalars['DateTime']['output'];
};


export type PartnerPlacementChptrsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PartnerPlacementContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContributionStatus>;
};

export type PartnerProduct = {
  __typename?: 'PartnerProduct';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mediaType?: Maybe<ProductMediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnerProperty = {
  __typename?: 'PartnerProperty';
  chptrs: ChptrConnection;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partner: Partner;
  placements: Array<PartnerPlacement>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PartnerPropertyChptrsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placementId?: InputMaybe<Scalars['String']['input']>;
  requireContributions?: InputMaybe<Scalars['Boolean']['input']>;
  visibilities?: InputMaybe<Array<ChptrVisibility>>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Placement = {
  __typename?: 'Placement';
  chptrType: ChptrType;
  chptrs: ChptrConnection;
  chptrsV2: ChptrConnection;
  configuration?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  events: EventConnection;
  eventsV2: EventConnection;
  featuredVideoContributions: Array<Contribution>;
  featuredVideoContributionsV2: Array<Contribution>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partner: Partner;
  property: Property;
  updatedAt: Scalars['DateTime']['output'];
};


export type PlacementChptrsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placementId?: InputMaybe<Scalars['String']['input']>;
  requireContributions?: InputMaybe<Scalars['Boolean']['input']>;
  visibilities?: InputMaybe<Array<ChptrVisibility>>;
};


export type PlacementChptrsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordersBy?: InputMaybe<ChptrOrderByInput>;
  placementId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  requireContributions?: InputMaybe<Scalars['Boolean']['input']>;
  visibilities?: InputMaybe<Array<ChptrVisibility>>;
};


export type PlacementEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordersBy?: InputMaybe<EventOrderByInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  startAtAfter?: InputMaybe<Scalars['String']['input']>;
};


export type PlacementEventsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordersBy?: InputMaybe<EventOrderByInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  startAtAfter?: InputMaybe<Scalars['String']['input']>;
};

export type Product = {
  __typename?: 'Product';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mediaType?: Maybe<ProductMediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  promotedAmount: Scalars['Int']['output'];
  promotions: Array<Promotion>;
  type: ProductType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProductMediaType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export enum ProductType {
  Addon = 'ADDON',
  Package = 'PACKAGE'
}

export type Promotion = {
  __typename?: 'Promotion';
  code: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  discountType: PromotionDiscountType;
  id: Scalars['ID']['output'];
  products: Array<PartnerProduct>;
  type: Scalars['String']['output'];
};

export enum PromotionDiscountType {
  Dollar = 'DOLLAR',
  Percentage = 'PERCENTAGE'
}

export type Property = {
  __typename?: 'Property';
  addons: Array<Product>;
  affiliatedTo: Array<Property>;
  affiliates: Array<Property>;
  chptrs: ChptrConnection;
  configuration: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partner: Partner;
  products: Array<Product>;
  type: PropertyType;
  updatedAt: Scalars['DateTime']['output'];
};


export type PropertyChptrsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum PropertyType {
  Affiliate = 'AFFILIATE',
  Primary = 'PRIMARY'
}

export type Query = {
  __typename?: 'Query';
  _: Scalars['String']['output'];
  chptr: Chptr;
  chptrRelationships: Array<ChptrRelationship>;
  chptrTags: Array<ChptrTag>;
  chptrs: ChptrConnection;
  contribution?: Maybe<Contribution>;
  mobileChptrs: ChptrConnection;
  placement?: Maybe<Placement>;
  property?: Maybe<Property>;
  user?: Maybe<User>;
};


export type QueryChptrArgs = {
  id: Scalars['String']['input'];
};


export type QueryChptrsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordersBy?: InputMaybe<ChptrOrderByInput>;
  placementId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  requireContributions?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  visibilities?: InputMaybe<Array<ChptrVisibility>>;
};


export type QueryContributionArgs = {
  id: Scalars['String']['input'];
};


export type QueryMobileChptrsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPlacementArgs = {
  id: Scalars['String']['input'];
};


export type QueryPropertyArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};

export type RegisterContributionUserInput = {
  firstName: Scalars['String']['input'];
  lastInitial: Scalars['String']['input'];
  placementId: Scalars['String']['input'];
};

export type RegisterUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  placementId?: InputMaybe<Scalars['String']['input']>;
};

export type Remove = {
  __typename?: 'Remove';
  id: Scalars['String']['output'];
};

export type RemoveOrderPromotionInput = {
  code: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type ReportContributionInput = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ResetUserPasswordInput = {
  id: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type Result = {
  __typename?: 'Result';
  success: Scalars['Boolean']['output'];
};

export type SendChptrInvitesInput = {
  emails: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type UpdateChptrInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  bornAt?: InputMaybe<DatePartsInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  passedAt?: InputMaybe<DatePartsInput>;
  picture?: InputMaybe<Scalars['Upload']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
  reps?: InputMaybe<Array<ChptrRepsInput>>;
  visibility?: InputMaybe<ChptrVisibility>;
};

export type UpdateChptrRepInput = {
  chptrId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContributionInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventInput = {
  endAt?: InputMaybe<Scalars['String']['input']>;
  eventAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationAddress?: InputMaybe<Scalars['JSON']['input']>;
  locationPlaceId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
  visitEndAt?: InputMaybe<Scalars['String']['input']>;
  visitLink?: InputMaybe<Scalars['String']['input']>;
  visitLocation?: InputMaybe<Scalars['String']['input']>;
  visitLocationAddress?: InputMaybe<Scalars['JSON']['input']>;
  visitLocationPlaceId?: InputMaybe<Scalars['String']['input']>;
  visitStartAt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
  id: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<OrderStatus>;
};

export type UpdatePaymentIntentInput = {
  id: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productIds: Array<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['Upload']['input']>;
};

export type User = {
  __typename?: 'User';
  chptrs: Array<ChptrUser>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isContributionUser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  notifications: Array<Notification>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  ownedChptrs: Array<Chptr>;
  pendingUploads: Array<ContributionUpload>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type UserOrderArgs = {
  id: Scalars['String']['input'];
};

export type UserAuthentication = {
  __typename?: 'UserAuthentication';
  token: Scalars['String']['output'];
  user: User;
};

export type ContributionCommentFragment = { __typename: 'Comment', id: string, text: string, status: CommentStatus, user: { __typename?: 'User', firstName: string, lastName: string } };

export type PlacementEventFragment = { __typename: 'Event', chptrId: string, createdAt: any, endAt?: any | null, id: string, link?: string | null, location?: string | null, locationPlaceId?: string | null, notes?: string | null, startAt?: any | null, updatedAt: any, visitLink?: string | null, visitLocation?: string | null, visitLocationPlaceId?: string | null, visitStartAt?: any | null, visitEndAt?: any | null, property?: { __typename?: 'Property', id: string, imageUrl?: string | null, name: string } | null, chptr?: { __typename?: 'Chptr', id: string, firstName: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, type: ChptrType, about?: string | null, location?: string | null, bornAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null } } | null };

export type PurchaseOrderFragment = { __typename: 'Order', id: string, amount: number, promotedAmount: number, status: OrderStatus, stripeKey: string, currency: string, chptr: { __typename: 'Chptr', id: string, type: ChptrType, firstName: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, visibility: ChptrVisibility, status: string, bornAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null } }, products: Array<{ __typename: 'Product', id: string, amount: number, promotedAmount: number, name: string, type: ProductType, mediaUrl?: string | null, mediaType?: ProductMediaType | null, description?: string | null, metadata: any }>, promotions: Array<{ __typename: 'Promotion', code: string, discountAmount: number, discountType: PromotionDiscountType, id: string, type: string }> };

export type PurchaseProductFragment = { __typename: 'Product', id: string, amount: number, promotedAmount: number, name: string, type: ProductType, mediaUrl?: string | null, mediaType?: ProductMediaType | null, description?: string | null, metadata: any };

export type AddOrderPromotionMutationVariables = Exact<{
  input: AddOrderPromotionInput;
}>;


export type AddOrderPromotionMutation = { __typename?: 'Mutation', addOrderPromotion: { __typename: 'Order', id: string, amount: number, promotedAmount: number, status: OrderStatus, stripeKey: string, currency: string, chptr: { __typename: 'Chptr', id: string, type: ChptrType, firstName: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, visibility: ChptrVisibility, status: string, bornAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null } }, products: Array<{ __typename: 'Product', id: string, amount: number, promotedAmount: number, name: string, type: ProductType, mediaUrl?: string | null, mediaType?: ProductMediaType | null, description?: string | null, metadata: any }>, promotions: Array<{ __typename: 'Promotion', code: string, discountAmount: number, discountType: PromotionDiscountType, id: string, type: string }> } };

export type AuthenticateUserMutationVariables = Exact<{
  input: AuthenticateUserInput;
}>;


export type AuthenticateUserMutation = { __typename?: 'Mutation', authenticateUser: { __typename?: 'UserAuthentication', token: string, user: { __typename: 'User', id: string, email?: string | null, firstName: string, lastName: string, isContributionUser: boolean } } };

export type CreateChptrMutationVariables = Exact<{
  input: CreateChptrInput;
}>;


export type CreateChptrMutation = { __typename?: 'Mutation', createChptr: { __typename: 'Chptr', id: string, pictureUrl?: string | null, webPictureUrl?: string | null, lastName: string, firstName: string, bornAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null } } };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createCommentV2: { __typename?: 'Comment', contribution: { __typename: 'Contribution', caption?: string | null, id: string, user: { __typename?: 'User', firstName: string, lastName: string }, comments: Array<{ __typename: 'Comment', id: string, text: string, status: CommentStatus, user: { __typename?: 'User', firstName: string, lastName: string } }> } } };

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename: 'Event', chptrId: string, createdAt: any, startAt?: any | null, endAt?: any | null, id: string, link?: string | null, location?: string | null, notes?: string | null, updatedAt: any } };

export type CreateImageContributionsMutationVariables = Exact<{
  input: Array<CreateImageContributionInput> | CreateImageContributionInput;
}>;


export type CreateImageContributionsMutation = { __typename?: 'Mutation', createImageContributions: Array<{ __typename: 'Contribution', id: string }> };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename: 'Order', id: string, status: OrderStatus, stripeKey: string, currency: string } };

export type CreatePaymentIntentMutationVariables = Exact<{
  input: CreatePaymentIntentInput;
}>;


export type CreatePaymentIntentMutation = { __typename?: 'Mutation', createPaymentIntent: { __typename: 'PaymentIntent', id: string, clientSecret: string } };

export type CreateTextContributionsMutationVariables = Exact<{
  input: Array<CreateTextContributionInput> | CreateTextContributionInput;
}>;


export type CreateTextContributionsMutation = { __typename?: 'Mutation', createTextContributions: Array<{ __typename: 'Contribution', id: string }> };

export type CreateVideoContributionUploadsMutationVariables = Exact<{
  input: Array<CreateAudioVideoContributionUploadInput> | CreateAudioVideoContributionUploadInput;
}>;


export type CreateVideoContributionUploadsMutation = { __typename?: 'Mutation', createVideoContributionUploads: Array<{ __typename: 'ContributionUpload', id: string, uploadUrl: string }> };

export type GetUserOrderQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
}>;


export type GetUserOrderQuery = { __typename?: 'Query', user?: { __typename?: 'User', order?: { __typename: 'Order', id: string, amount: number, promotedAmount: number, status: OrderStatus, stripeKey: string, currency: string, chptr: { __typename: 'Chptr', id: string, type: ChptrType, firstName: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, visibility: ChptrVisibility, status: string, bornAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null } }, products: Array<{ __typename: 'Product', id: string, amount: number, promotedAmount: number, name: string, type: ProductType, mediaUrl?: string | null, mediaType?: ProductMediaType | null, description?: string | null, metadata: any }>, promotions: Array<{ __typename: 'Promotion', code: string, discountAmount: number, discountType: PromotionDiscountType, id: string, type: string }> } | null } | null };

export type LoginUserMutationVariables = Exact<{
  input: LoginUserInput;
}>;


export type LoginUserMutation = { __typename?: 'Mutation', loginUser: { __typename?: 'UserAuthentication', token: string, user: { __typename: 'User', id: string, email?: string | null, firstName: string, lastName: string, isContributionUser: boolean } } };

export type RegisterContributionUserMutationVariables = Exact<{
  input: RegisterContributionUserInput;
}>;


export type RegisterContributionUserMutation = { __typename?: 'Mutation', registerContributionUser: { __typename?: 'UserAuthentication', token: string, user: { __typename: 'User', id: string, email?: string | null, firstName: string, lastName: string, isContributionUser: boolean } } };

export type RegisterUserMutationVariables = Exact<{
  input: RegisterUserInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', registerUser: { __typename?: 'UserAuthentication', token: string, user: { __typename: 'User', id: string, email?: string | null, firstName: string, lastName: string, isContributionUser: boolean } } };

export type RemoveOrderPromotionMutationVariables = Exact<{
  input: RemoveOrderPromotionInput;
}>;


export type RemoveOrderPromotionMutation = { __typename?: 'Mutation', removeOrderPromotion: { __typename: 'Order', id: string, amount: number, promotedAmount: number, status: OrderStatus, stripeKey: string, currency: string, chptr: { __typename: 'Chptr', id: string, type: ChptrType, firstName: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, visibility: ChptrVisibility, status: string, bornAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null } }, products: Array<{ __typename: 'Product', id: string, amount: number, promotedAmount: number, name: string, type: ProductType, mediaUrl?: string | null, mediaType?: ProductMediaType | null, description?: string | null, metadata: any }>, promotions: Array<{ __typename: 'Promotion', code: string, discountAmount: number, discountType: PromotionDiscountType, id: string, type: string }> } };

export type UpdateChptrMutationVariables = Exact<{
  input: UpdateChptrInput;
}>;


export type UpdateChptrMutation = { __typename?: 'Mutation', updateChptr: { __typename: 'Chptr', id: string, pictureUrl?: string | null, webPictureUrl?: string | null, lastName: string, about?: string | null, firstName: string, bornAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null } } };

export type UpdateEventMutationVariables = Exact<{
  input: UpdateEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename: 'Event', chptrId: string, createdAt: any, startAt?: any | null, endAt?: any | null, id: string, link?: string | null, location?: string | null, locationPlaceId?: string | null, visitLocationPlaceId?: string | null, notes?: string | null, updatedAt: any } };

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename: 'Order', amount: number, id: string, promotedAmount: number, status: OrderStatus, stripeKey: string, currency: string, products: Array<{ __typename?: 'Product', amount: number, id: string, promotedAmount: number, name: string, description?: string | null, createdAt: any }>, promotions: Array<{ __typename: 'Promotion', code: string, discountAmount: number, discountType: PromotionDiscountType, id: string, type: string }> } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename: 'User', id: string, email?: string | null, firstName: string, lastName: string, isContributionUser: boolean } };

export type GetAffiliatesQueryVariables = Exact<{
  placementId: Scalars['String']['input'];
}>;


export type GetAffiliatesQuery = { __typename?: 'Query', placement?: { __typename?: 'Placement', property: { __typename?: 'Property', id: string, name: string, imageUrl?: string | null, type: PropertyType, affiliates: Array<{ __typename?: 'Property', id: string, imageUrl?: string | null, name: string }> } } | null };

export type GetChptrContributionsQueryVariables = Exact<{
  chptrId: Scalars['String']['input'];
  contributionsFirst?: InputMaybe<Scalars['Int']['input']>;
  contributionsAfter?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<ContributionMediaType>;
  orderBy?: InputMaybe<ContributionOrderByInput>;
}>;


export type GetChptrContributionsQuery = { __typename?: 'Query', chptr: { __typename: 'Chptr', type: ChptrType, firstName: string, id: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, visibility: ChptrVisibility, about?: string | null, location?: string | null, passedAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, bornAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, property?: { __typename?: 'Property', id: string, name: string, imageUrl?: string | null } | null, reps: Array<{ __typename: 'ChptrRep', id: string, name?: string | null, email?: string | null, phone?: string | null }>, events: Array<{ __typename: 'Event', id: string, location?: string | null, locationPlaceId?: string | null, link?: string | null, startAt?: any | null, endAt?: any | null, visitLocation?: string | null, visitLocationPlaceId?: string | null, visitLink?: string | null, visitStartAt?: any | null, visitEndAt?: any | null, notes?: string | null, property?: { __typename?: 'Property', id: string, imageUrl?: string | null, name: string } | null }>, contributions: { __typename?: 'ContributionConnection', totalCount: number, pageInfo: { __typename?: 'ConnectionPageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'ContributionNode', node: { __typename?: 'Contribution', caption?: string | null, createdAt: any, id: string, mediaType: ContributionMediaType, thumbnailUrl?: string | null, blurHash?: string | null, title?: string | null, type: ContributionType, url?: string | null, commentsV2: { __typename?: 'CommentConnection', totalCount: number }, user: { __typename?: 'User', firstName: string, id: string, lastName: string, pictureUrl?: string | null } } }> }, featuredContributions: Array<{ __typename?: 'Contribution', id: string, caption?: string | null, mediaType: ContributionMediaType, thumbnailUrl?: string | null, blurHash?: string | null, title?: string | null, type: ContributionType, url?: string | null, commentsV2: { __typename?: 'CommentConnection', totalCount: number } }>, users: Array<{ __typename?: 'ChptrUser', user: { __typename?: 'User', firstName: string, lastName: string, id: string } }>, owner: { __typename?: 'ChptrOwner', user: { __typename?: 'User', id: string, firstName: string, lastName: string } } } };

export type GetChptrEventsQueryVariables = Exact<{
  chptrId: Scalars['String']['input'];
}>;


export type GetChptrEventsQuery = { __typename?: 'Query', chptr: { __typename: 'Chptr', id: string, type: ChptrType, firstName: string, lastName: string, location?: string | null, about?: string | null, pictureUrl?: string | null, webPictureUrl?: string | null, reps: Array<{ __typename: 'ChptrRep', id: string, name?: string | null, email?: string | null, phone?: string | null }>, property?: { __typename?: 'Property', id: string, name: string, imageUrl?: string | null } | null, passedAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, bornAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, events: Array<{ __typename: 'Event', id: string, location?: string | null, locationPlaceId?: string | null, link?: string | null, startAt?: any | null, endAt?: any | null, visitLocation?: string | null, visitLocationPlaceId?: string | null, visitLink?: string | null, visitStartAt?: any | null, visitEndAt?: any | null, notes?: string | null, property?: { __typename?: 'Property', id: string, imageUrl?: string | null, name: string } | null }>, owner: { __typename?: 'ChptrOwner', user: { __typename?: 'User', id: string, firstName: string, lastName: string } } } };

export type GetContributionCommentsQueryVariables = Exact<{
  contributionId: Scalars['String']['input'];
  commentsFirst?: InputMaybe<Scalars['Int']['input']>;
  commentsAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContributionCommentsQuery = { __typename?: 'Query', contribution?: { __typename: 'Contribution', caption?: string | null, id: string, mediaType: ContributionMediaType, blurHash?: string | null, url?: string | null, user: { __typename?: 'User', firstName: string, lastName: string }, commentsV2: { __typename?: 'CommentConnection', totalCount: number, edges: Array<{ __typename?: 'CommentNode', cursor: string, node: { __typename: 'Comment', id: string, text: string, status: CommentStatus, user: { __typename?: 'User', firstName: string, lastName: string } } }>, pageInfo: { __typename?: 'ConnectionPageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type GetHomeQueryVariables = Exact<{
  visibilities?: InputMaybe<Array<ChptrVisibility> | ChptrVisibility>;
  placementId: Scalars['String']['input'];
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  chptrsFirst?: InputMaybe<Scalars['Int']['input']>;
  contributionsFirst?: InputMaybe<Scalars['Int']['input']>;
  requireContributions?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  ordersBy?: InputMaybe<ChptrOrderByInput>;
  eventsFirst?: InputMaybe<Scalars['Int']['input']>;
  eventsStartAtAfter?: InputMaybe<Scalars['String']['input']>;
  eventsQuery?: InputMaybe<Scalars['String']['input']>;
  eventsAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHomeQuery = { __typename?: 'Query', placement?: { __typename?: 'Placement', name: string, id: string, chptrType: ChptrType, configuration?: any | null, property: { __typename?: 'Property', name: string, currency: string, addons: Array<{ __typename: 'Product', id: string, amount: number, promotedAmount: number, name: string, type: ProductType, mediaUrl?: string | null, mediaType?: ProductMediaType | null, description?: string | null, metadata: any }>, products: Array<{ __typename: 'Product', id: string, amount: number, promotedAmount: number, name: string, type: ProductType, mediaUrl?: string | null, mediaType?: ProductMediaType | null, description?: string | null, metadata: any }>, partner: { __typename?: 'Partner', name: string } }, events: { __typename?: 'EventConnection', totalCount: number, edges: Array<{ __typename?: 'EventNode', cursor: string, node: { __typename: 'Event', chptrId: string, createdAt: any, endAt?: any | null, id: string, link?: string | null, location?: string | null, locationPlaceId?: string | null, notes?: string | null, startAt?: any | null, updatedAt: any, visitLink?: string | null, visitLocation?: string | null, visitLocationPlaceId?: string | null, visitStartAt?: any | null, visitEndAt?: any | null, property?: { __typename?: 'Property', id: string, imageUrl?: string | null, name: string } | null, chptr?: { __typename?: 'Chptr', id: string, firstName: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, type: ChptrType, about?: string | null, location?: string | null, bornAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null } } | null } }>, pageInfo: { __typename?: 'ConnectionPageInfo', hasNextPage: boolean, endCursor?: string | null } }, featuredVideoContributions: Array<{ __typename?: 'Contribution', caption?: string | null, id: string, mediaType: ContributionMediaType, thumbnailUrl?: string | null, url?: string | null, chptr: { __typename?: 'Chptr', id: string, firstName: string, lastName: string, type: ChptrType } }>, chptrs: { __typename: 'ChptrConnection', totalCount: number, pageInfo: { __typename?: 'ConnectionPageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'ChptrNode', node: { __typename: 'Chptr', type: ChptrType, firstName: string, id: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, visibility: ChptrVisibility, location?: string | null, bornAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, events: Array<{ __typename?: 'Event', location?: string | null, property?: { __typename?: 'Property', name: string } | null }>, property?: { __typename?: 'Property', name: string } | null, contributions: { __typename?: 'ContributionConnection', totalCount: number, edges: Array<{ __typename?: 'ContributionNode', node: { __typename: 'Contribution', caption?: string | null, mediaType: ContributionMediaType, url?: string | null, thumbnailUrl?: string | null, blurHash?: string | null, user: { __typename?: 'User', firstName: string, lastName: string, id: string } } }> } } }> } } | null };

export type GetPlacementConfigurationQueryVariables = Exact<{
  placementId: Scalars['String']['input'];
}>;


export type GetPlacementConfigurationQuery = { __typename?: 'Query', placement?: { __typename?: 'Placement', id: string, chptrType: ChptrType, configuration?: any | null } | null };

export type GetPlacementEventsQueryVariables = Exact<{
  placementId: Scalars['String']['input'];
  eventsFirst?: InputMaybe<Scalars['Int']['input']>;
  eventsStartAtAfter?: InputMaybe<Scalars['String']['input']>;
  eventsQuery?: InputMaybe<Scalars['String']['input']>;
  eventsAfter?: InputMaybe<Scalars['String']['input']>;
  eventsOrdersBy?: InputMaybe<EventOrderByInput>;
}>;


export type GetPlacementEventsQuery = { __typename?: 'Query', placement?: { __typename: 'Placement', id: string, events: { __typename?: 'EventConnection', totalCount: number, edges: Array<{ __typename?: 'EventNode', cursor: string, node: { __typename: 'Event', chptrId: string, createdAt: any, endAt?: any | null, id: string, link?: string | null, location?: string | null, locationPlaceId?: string | null, notes?: string | null, startAt?: any | null, updatedAt: any, visitLink?: string | null, visitLocation?: string | null, visitLocationPlaceId?: string | null, visitStartAt?: any | null, visitEndAt?: any | null, property?: { __typename?: 'Property', id: string, imageUrl?: string | null, name: string } | null, chptr?: { __typename?: 'Chptr', id: string, firstName: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, type: ChptrType, about?: string | null, location?: string | null, bornAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', month?: number | null, day?: number | null, year?: number | null } } | null } }>, pageInfo: { __typename?: 'ConnectionPageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type GetPlacementFeaturedVideosQueryVariables = Exact<{
  placementId: Scalars['String']['input'];
}>;


export type GetPlacementFeaturedVideosQuery = { __typename?: 'Query', placement?: { __typename?: 'Placement', id: string, featuredVideoContributions: Array<{ __typename?: 'Contribution', caption?: string | null, id: string, mediaType: ContributionMediaType, thumbnailUrl?: string | null, url?: string | null, chptr: { __typename?: 'Chptr', id: string, firstName: string, lastName: string, type: ChptrType } }> } | null };

export type GetPlacementPartnerTermsQueryVariables = Exact<{
  placementId: Scalars['String']['input'];
}>;


export type GetPlacementPartnerTermsQuery = { __typename?: 'Query', placement?: { __typename?: 'Placement', partner: { __typename?: 'Partner', id: string } } | null };

export type GetRecentChptrsQueryVariables = Exact<{
  visibilities?: InputMaybe<Array<ChptrVisibility> | ChptrVisibility>;
  placementId: Scalars['String']['input'];
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  chptrsFirst?: InputMaybe<Scalars['Int']['input']>;
  contributionsFirst?: InputMaybe<Scalars['Int']['input']>;
  requireContributions?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  ordersBy?: InputMaybe<ChptrOrderByInput>;
}>;


export type GetRecentChptrsQuery = { __typename?: 'Query', placement?: { __typename?: 'Placement', chptrs: { __typename: 'ChptrConnection', totalCount: number, pageInfo: { __typename?: 'ConnectionPageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'ChptrNode', node: { __typename: 'Chptr', type: ChptrType, firstName: string, id: string, lastName: string, pictureUrl?: string | null, webPictureUrl?: string | null, visibility: ChptrVisibility, bornAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, passedAt: { __typename?: 'DateParts', day?: number | null, month?: number | null, year?: number | null }, contributions: { __typename?: 'ContributionConnection', totalCount: number, edges: Array<{ __typename?: 'ContributionNode', node: { __typename: 'Contribution', caption?: string | null, mediaType: ContributionMediaType, url?: string | null, thumbnailUrl?: string | null, blurHash?: string | null, user: { __typename?: 'User', firstName: string, lastName: string, id: string } } }> } } }> } } | null };

export type PlacementQueryVariables = Exact<{
  placementId: Scalars['String']['input'];
}>;


export type PlacementQuery = { __typename?: 'Query', placement?: { __typename?: 'Placement', name: string, id: string, chptrType: ChptrType, configuration?: any | null, property: { __typename?: 'Property', name: string, currency: string, addons: Array<{ __typename: 'Product', id: string, amount: number, promotedAmount: number, name: string, type: ProductType, mediaUrl?: string | null, mediaType?: ProductMediaType | null, description?: string | null, metadata: any }>, products: Array<{ __typename: 'Product', id: string, amount: number, promotedAmount: number, name: string, type: ProductType, mediaUrl?: string | null, mediaType?: ProductMediaType | null, description?: string | null, metadata: any }>, partner: { __typename?: 'Partner', name: string } } } | null };

export type UserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename: 'User', email?: string | null, firstName: string, lastName: string } | null };

export const ContributionCommentFragmentDoc = gql`
    fragment ContributionComment on Comment {
  __typename
  id
  text
  status
  user {
    firstName
    lastName
  }
}
    `;
export const PlacementEventFragmentDoc = gql`
    fragment PlacementEvent on Event {
  __typename
  chptrId
  createdAt
  endAt
  id
  link
  location
  locationPlaceId
  notes
  startAt
  updatedAt
  visitLink
  visitLocation
  visitLocationPlaceId
  visitStartAt
  visitEndAt
  property {
    id
    imageUrl
    name
  }
  chptr {
    id
    firstName
    lastName
    pictureUrl
    webPictureUrl
    type
    about
    location
    bornAt {
      month
      day
      year
    }
    passedAt {
      month
      day
      year
    }
  }
}
    `;
export const PurchaseProductFragmentDoc = gql`
    fragment PurchaseProduct on Product {
  __typename
  id
  amount
  promotedAmount
  name
  type
  mediaUrl
  mediaType
  description
  metadata
}
    `;
export const PurchaseOrderFragmentDoc = gql`
    fragment PurchaseOrder on Order {
  __typename
  id
  chptr {
    __typename
    id
    type
    firstName
    lastName
    pictureUrl
    webPictureUrl
    bornAt {
      month
      day
      year
    }
    passedAt {
      month
      day
      year
    }
    visibility
    status
  }
  products {
    ...PurchaseProduct
  }
  amount
  promotedAmount
  promotions {
    __typename
    code
    discountAmount
    discountType
    id
    type
  }
  status
  stripeKey
  currency
}
    ${PurchaseProductFragmentDoc}`;
export const AddOrderPromotionDocument = gql`
    mutation addOrderPromotion($input: AddOrderPromotionInput!) {
  addOrderPromotion(input: $input) {
    ...PurchaseOrder
  }
}
    ${PurchaseOrderFragmentDoc}`;
export type AddOrderPromotionMutationFn = Apollo.MutationFunction<AddOrderPromotionMutation, AddOrderPromotionMutationVariables>;

/**
 * __useAddOrderPromotionMutation__
 *
 * To run a mutation, you first call `useAddOrderPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderPromotionMutation, { data, loading, error }] = useAddOrderPromotionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderPromotionMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderPromotionMutation, AddOrderPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderPromotionMutation, AddOrderPromotionMutationVariables>(AddOrderPromotionDocument, options);
      }
export type AddOrderPromotionMutationHookResult = ReturnType<typeof useAddOrderPromotionMutation>;
export type AddOrderPromotionMutationResult = Apollo.MutationResult<AddOrderPromotionMutation>;
export type AddOrderPromotionMutationOptions = Apollo.BaseMutationOptions<AddOrderPromotionMutation, AddOrderPromotionMutationVariables>;
export const AuthenticateUserDocument = gql`
    mutation AuthenticateUser($input: AuthenticateUserInput!) {
  authenticateUser(input: $input) {
    token
    user {
      __typename
      id
      email
      firstName
      lastName
      isContributionUser
    }
  }
}
    `;
export type AuthenticateUserMutationFn = Apollo.MutationFunction<AuthenticateUserMutation, AuthenticateUserMutationVariables>;

/**
 * __useAuthenticateUserMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserMutation, { data, loading, error }] = useAuthenticateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateUserMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateUserMutation, AuthenticateUserMutationVariables>(AuthenticateUserDocument, options);
      }
export type AuthenticateUserMutationHookResult = ReturnType<typeof useAuthenticateUserMutation>;
export type AuthenticateUserMutationResult = Apollo.MutationResult<AuthenticateUserMutation>;
export type AuthenticateUserMutationOptions = Apollo.BaseMutationOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>;
export const CreateChptrDocument = gql`
    mutation CreateChptr($input: CreateChptrInput!) {
  createChptr(input: $input) {
    __typename
    id
    pictureUrl
    webPictureUrl
    lastName
    bornAt {
      day
      month
      year
    }
    passedAt {
      day
      month
      year
    }
    firstName
  }
}
    `;
export type CreateChptrMutationFn = Apollo.MutationFunction<CreateChptrMutation, CreateChptrMutationVariables>;

/**
 * __useCreateChptrMutation__
 *
 * To run a mutation, you first call `useCreateChptrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChptrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChptrMutation, { data, loading, error }] = useCreateChptrMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChptrMutation(baseOptions?: Apollo.MutationHookOptions<CreateChptrMutation, CreateChptrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChptrMutation, CreateChptrMutationVariables>(CreateChptrDocument, options);
      }
export type CreateChptrMutationHookResult = ReturnType<typeof useCreateChptrMutation>;
export type CreateChptrMutationResult = Apollo.MutationResult<CreateChptrMutation>;
export type CreateChptrMutationOptions = Apollo.BaseMutationOptions<CreateChptrMutation, CreateChptrMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($input: CreateCommentInput!) {
  createCommentV2(input: $input) {
    contribution {
      __typename
      user {
        firstName
        lastName
      }
      caption
      id
      comments {
        ...ContributionComment
      }
    }
  }
}
    ${ContributionCommentFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($input: CreateEventInput!) {
  createEvent(input: $input) {
    __typename
    chptrId
    createdAt
    startAt
    endAt
    id
    link
    location
    notes
    updatedAt
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateImageContributionsDocument = gql`
    mutation CreateImageContributions($input: [CreateImageContributionInput!]!) {
  createImageContributions(input: $input) {
    __typename
    id
  }
}
    `;
export type CreateImageContributionsMutationFn = Apollo.MutationFunction<CreateImageContributionsMutation, CreateImageContributionsMutationVariables>;

/**
 * __useCreateImageContributionsMutation__
 *
 * To run a mutation, you first call `useCreateImageContributionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageContributionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageContributionsMutation, { data, loading, error }] = useCreateImageContributionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImageContributionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateImageContributionsMutation, CreateImageContributionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImageContributionsMutation, CreateImageContributionsMutationVariables>(CreateImageContributionsDocument, options);
      }
export type CreateImageContributionsMutationHookResult = ReturnType<typeof useCreateImageContributionsMutation>;
export type CreateImageContributionsMutationResult = Apollo.MutationResult<CreateImageContributionsMutation>;
export type CreateImageContributionsMutationOptions = Apollo.BaseMutationOptions<CreateImageContributionsMutation, CreateImageContributionsMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    __typename
    id
    status
    stripeKey
    currency
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const CreatePaymentIntentDocument = gql`
    mutation CreatePaymentIntent($input: CreatePaymentIntentInput!) {
  createPaymentIntent(input: $input) {
    __typename
    id
    clientSecret
  }
}
    `;
export type CreatePaymentIntentMutationFn = Apollo.MutationFunction<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;

/**
 * __useCreatePaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentIntentMutation, { data, loading, error }] = useCreatePaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>(CreatePaymentIntentDocument, options);
      }
export type CreatePaymentIntentMutationHookResult = ReturnType<typeof useCreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationResult = Apollo.MutationResult<CreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;
export const CreateTextContributionsDocument = gql`
    mutation CreateTextContributions($input: [CreateTextContributionInput!]!) {
  createTextContributions(input: $input) {
    __typename
    id
  }
}
    `;
export type CreateTextContributionsMutationFn = Apollo.MutationFunction<CreateTextContributionsMutation, CreateTextContributionsMutationVariables>;

/**
 * __useCreateTextContributionsMutation__
 *
 * To run a mutation, you first call `useCreateTextContributionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTextContributionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTextContributionsMutation, { data, loading, error }] = useCreateTextContributionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTextContributionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateTextContributionsMutation, CreateTextContributionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTextContributionsMutation, CreateTextContributionsMutationVariables>(CreateTextContributionsDocument, options);
      }
export type CreateTextContributionsMutationHookResult = ReturnType<typeof useCreateTextContributionsMutation>;
export type CreateTextContributionsMutationResult = Apollo.MutationResult<CreateTextContributionsMutation>;
export type CreateTextContributionsMutationOptions = Apollo.BaseMutationOptions<CreateTextContributionsMutation, CreateTextContributionsMutationVariables>;
export const CreateVideoContributionUploadsDocument = gql`
    mutation CreateVideoContributionUploads($input: [CreateAudioVideoContributionUploadInput!]!) {
  createVideoContributionUploads(input: $input) {
    __typename
    id
    uploadUrl
  }
}
    `;
export type CreateVideoContributionUploadsMutationFn = Apollo.MutationFunction<CreateVideoContributionUploadsMutation, CreateVideoContributionUploadsMutationVariables>;

/**
 * __useCreateVideoContributionUploadsMutation__
 *
 * To run a mutation, you first call `useCreateVideoContributionUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoContributionUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoContributionUploadsMutation, { data, loading, error }] = useCreateVideoContributionUploadsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideoContributionUploadsMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoContributionUploadsMutation, CreateVideoContributionUploadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoContributionUploadsMutation, CreateVideoContributionUploadsMutationVariables>(CreateVideoContributionUploadsDocument, options);
      }
export type CreateVideoContributionUploadsMutationHookResult = ReturnType<typeof useCreateVideoContributionUploadsMutation>;
export type CreateVideoContributionUploadsMutationResult = Apollo.MutationResult<CreateVideoContributionUploadsMutation>;
export type CreateVideoContributionUploadsMutationOptions = Apollo.BaseMutationOptions<CreateVideoContributionUploadsMutation, CreateVideoContributionUploadsMutationVariables>;
export const GetUserOrderDocument = gql`
    query GetUserOrder($userId: String!, $orderId: String!) {
  user(id: $userId) {
    order(id: $orderId) {
      ...PurchaseOrder
    }
  }
}
    ${PurchaseOrderFragmentDoc}`;

/**
 * __useGetUserOrderQuery__
 *
 * To run a query within a React component, call `useGetUserOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrderQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetUserOrderQuery(baseOptions: Apollo.QueryHookOptions<GetUserOrderQuery, GetUserOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserOrderQuery, GetUserOrderQueryVariables>(GetUserOrderDocument, options);
      }
export function useGetUserOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOrderQuery, GetUserOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserOrderQuery, GetUserOrderQueryVariables>(GetUserOrderDocument, options);
        }
export function useGetUserOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserOrderQuery, GetUserOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserOrderQuery, GetUserOrderQueryVariables>(GetUserOrderDocument, options);
        }
export type GetUserOrderQueryHookResult = ReturnType<typeof useGetUserOrderQuery>;
export type GetUserOrderLazyQueryHookResult = ReturnType<typeof useGetUserOrderLazyQuery>;
export type GetUserOrderSuspenseQueryHookResult = ReturnType<typeof useGetUserOrderSuspenseQuery>;
export type GetUserOrderQueryResult = Apollo.QueryResult<GetUserOrderQuery, GetUserOrderQueryVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($input: LoginUserInput!) {
  loginUser(input: $input) {
    token
    user {
      __typename
      id
      email
      firstName
      lastName
      isContributionUser
    }
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const RegisterContributionUserDocument = gql`
    mutation RegisterContributionUser($input: RegisterContributionUserInput!) {
  registerContributionUser(input: $input) {
    token
    user {
      __typename
      id
      email
      firstName
      lastName
      isContributionUser
    }
  }
}
    `;
export type RegisterContributionUserMutationFn = Apollo.MutationFunction<RegisterContributionUserMutation, RegisterContributionUserMutationVariables>;

/**
 * __useRegisterContributionUserMutation__
 *
 * To run a mutation, you first call `useRegisterContributionUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterContributionUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerContributionUserMutation, { data, loading, error }] = useRegisterContributionUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterContributionUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterContributionUserMutation, RegisterContributionUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterContributionUserMutation, RegisterContributionUserMutationVariables>(RegisterContributionUserDocument, options);
      }
export type RegisterContributionUserMutationHookResult = ReturnType<typeof useRegisterContributionUserMutation>;
export type RegisterContributionUserMutationResult = Apollo.MutationResult<RegisterContributionUserMutation>;
export type RegisterContributionUserMutationOptions = Apollo.BaseMutationOptions<RegisterContributionUserMutation, RegisterContributionUserMutationVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($input: RegisterUserInput!) {
  registerUser(input: $input) {
    token
    user {
      __typename
      id
      email
      firstName
      lastName
      isContributionUser
    }
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const RemoveOrderPromotionDocument = gql`
    mutation RemoveOrderPromotion($input: RemoveOrderPromotionInput!) {
  removeOrderPromotion(input: $input) {
    ...PurchaseOrder
  }
}
    ${PurchaseOrderFragmentDoc}`;
export type RemoveOrderPromotionMutationFn = Apollo.MutationFunction<RemoveOrderPromotionMutation, RemoveOrderPromotionMutationVariables>;

/**
 * __useRemoveOrderPromotionMutation__
 *
 * To run a mutation, you first call `useRemoveOrderPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderPromotionMutation, { data, loading, error }] = useRemoveOrderPromotionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrderPromotionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrderPromotionMutation, RemoveOrderPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrderPromotionMutation, RemoveOrderPromotionMutationVariables>(RemoveOrderPromotionDocument, options);
      }
export type RemoveOrderPromotionMutationHookResult = ReturnType<typeof useRemoveOrderPromotionMutation>;
export type RemoveOrderPromotionMutationResult = Apollo.MutationResult<RemoveOrderPromotionMutation>;
export type RemoveOrderPromotionMutationOptions = Apollo.BaseMutationOptions<RemoveOrderPromotionMutation, RemoveOrderPromotionMutationVariables>;
export const UpdateChptrDocument = gql`
    mutation UpdateChptr($input: UpdateChptrInput!) {
  updateChptr(input: $input) {
    __typename
    id
    pictureUrl
    webPictureUrl
    lastName
    about
    bornAt {
      day
      month
      year
    }
    passedAt {
      day
      month
      year
    }
    firstName
  }
}
    `;
export type UpdateChptrMutationFn = Apollo.MutationFunction<UpdateChptrMutation, UpdateChptrMutationVariables>;

/**
 * __useUpdateChptrMutation__
 *
 * To run a mutation, you first call `useUpdateChptrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChptrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChptrMutation, { data, loading, error }] = useUpdateChptrMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChptrMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChptrMutation, UpdateChptrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChptrMutation, UpdateChptrMutationVariables>(UpdateChptrDocument, options);
      }
export type UpdateChptrMutationHookResult = ReturnType<typeof useUpdateChptrMutation>;
export type UpdateChptrMutationResult = Apollo.MutationResult<UpdateChptrMutation>;
export type UpdateChptrMutationOptions = Apollo.BaseMutationOptions<UpdateChptrMutation, UpdateChptrMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($input: UpdateEventInput!) {
  updateEvent(input: $input) {
    __typename
    chptrId
    createdAt
    startAt
    endAt
    id
    link
    location
    locationPlaceId
    visitLocationPlaceId
    notes
    updatedAt
  }
}
    `;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderInput!) {
  updateOrder(input: $input) {
    __typename
    amount
    id
    products {
      amount
      id
      promotedAmount
      name
      description
      createdAt
    }
    promotedAmount
    promotions {
      __typename
      code
      discountAmount
      discountType
      id
      type
    }
    status
    stripeKey
    currency
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    __typename
    id
    email
    firstName
    lastName
    isContributionUser
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetAffiliatesDocument = gql`
    query getAffiliates($placementId: String!) {
  placement(id: $placementId) {
    property {
      id
      name
      imageUrl
      type
      affiliates {
        id
        imageUrl
        name
      }
    }
  }
}
    `;

/**
 * __useGetAffiliatesQuery__
 *
 * To run a query within a React component, call `useGetAffiliatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffiliatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffiliatesQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *   },
 * });
 */
export function useGetAffiliatesQuery(baseOptions: Apollo.QueryHookOptions<GetAffiliatesQuery, GetAffiliatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAffiliatesQuery, GetAffiliatesQueryVariables>(GetAffiliatesDocument, options);
      }
export function useGetAffiliatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAffiliatesQuery, GetAffiliatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAffiliatesQuery, GetAffiliatesQueryVariables>(GetAffiliatesDocument, options);
        }
export function useGetAffiliatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAffiliatesQuery, GetAffiliatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAffiliatesQuery, GetAffiliatesQueryVariables>(GetAffiliatesDocument, options);
        }
export type GetAffiliatesQueryHookResult = ReturnType<typeof useGetAffiliatesQuery>;
export type GetAffiliatesLazyQueryHookResult = ReturnType<typeof useGetAffiliatesLazyQuery>;
export type GetAffiliatesSuspenseQueryHookResult = ReturnType<typeof useGetAffiliatesSuspenseQuery>;
export type GetAffiliatesQueryResult = Apollo.QueryResult<GetAffiliatesQuery, GetAffiliatesQueryVariables>;
export const GetChptrContributionsDocument = gql`
    query GetChptrContributions($chptrId: String!, $contributionsFirst: Int, $contributionsAfter: String, $mediaType: ContributionMediaType, $orderBy: ContributionOrderByInput) {
  chptr(id: $chptrId) {
    __typename
    type
    firstName
    id
    lastName
    passedAt {
      day
      month
      year
    }
    pictureUrl
    webPictureUrl
    bornAt {
      day
      month
      year
    }
    visibility
    about
    location
    property {
      id
      name
      imageUrl
    }
    reps {
      __typename
      id
      name
      email
      phone
    }
    events {
      __typename
      id
      location
      locationPlaceId
      link
      startAt
      endAt
      visitLocation
      visitLocationPlaceId
      visitLink
      visitStartAt
      visitEndAt
      property {
        id
        imageUrl
        name
      }
      notes
    }
    contributions(
      first: $contributionsFirst
      after: $contributionsAfter
      mediaType: $mediaType
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          caption
          commentsV2 {
            totalCount
          }
          createdAt
          id
          mediaType
          thumbnailUrl
          blurHash
          title
          type
          url
          user {
            firstName
            id
            lastName
            pictureUrl
          }
        }
      }
    }
    featuredContributions {
      id
      caption
      mediaType
      thumbnailUrl
      blurHash
      title
      type
      url
      commentsV2 {
        totalCount
      }
    }
    users {
      user {
        firstName
        lastName
        id
      }
    }
    owner {
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetChptrContributionsQuery__
 *
 * To run a query within a React component, call `useGetChptrContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChptrContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChptrContributionsQuery({
 *   variables: {
 *      chptrId: // value for 'chptrId'
 *      contributionsFirst: // value for 'contributionsFirst'
 *      contributionsAfter: // value for 'contributionsAfter'
 *      mediaType: // value for 'mediaType'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetChptrContributionsQuery(baseOptions: Apollo.QueryHookOptions<GetChptrContributionsQuery, GetChptrContributionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChptrContributionsQuery, GetChptrContributionsQueryVariables>(GetChptrContributionsDocument, options);
      }
export function useGetChptrContributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChptrContributionsQuery, GetChptrContributionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChptrContributionsQuery, GetChptrContributionsQueryVariables>(GetChptrContributionsDocument, options);
        }
export function useGetChptrContributionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChptrContributionsQuery, GetChptrContributionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChptrContributionsQuery, GetChptrContributionsQueryVariables>(GetChptrContributionsDocument, options);
        }
export type GetChptrContributionsQueryHookResult = ReturnType<typeof useGetChptrContributionsQuery>;
export type GetChptrContributionsLazyQueryHookResult = ReturnType<typeof useGetChptrContributionsLazyQuery>;
export type GetChptrContributionsSuspenseQueryHookResult = ReturnType<typeof useGetChptrContributionsSuspenseQuery>;
export type GetChptrContributionsQueryResult = Apollo.QueryResult<GetChptrContributionsQuery, GetChptrContributionsQueryVariables>;
export const GetChptrEventsDocument = gql`
    query GetChptrEvents($chptrId: String!) {
  chptr(id: $chptrId) {
    __typename
    id
    type
    firstName
    lastName
    location
    about
    reps {
      __typename
      id
      name
      email
      phone
    }
    property {
      id
      name
      imageUrl
    }
    passedAt {
      day
      month
      year
    }
    pictureUrl
    webPictureUrl
    bornAt {
      day
      month
      year
    }
    events {
      __typename
      id
      location
      locationPlaceId
      link
      startAt
      endAt
      visitLocation
      visitLocationPlaceId
      visitLink
      visitStartAt
      visitEndAt
      property {
        id
        imageUrl
        name
      }
      notes
    }
    owner {
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetChptrEventsQuery__
 *
 * To run a query within a React component, call `useGetChptrEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChptrEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChptrEventsQuery({
 *   variables: {
 *      chptrId: // value for 'chptrId'
 *   },
 * });
 */
export function useGetChptrEventsQuery(baseOptions: Apollo.QueryHookOptions<GetChptrEventsQuery, GetChptrEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChptrEventsQuery, GetChptrEventsQueryVariables>(GetChptrEventsDocument, options);
      }
export function useGetChptrEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChptrEventsQuery, GetChptrEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChptrEventsQuery, GetChptrEventsQueryVariables>(GetChptrEventsDocument, options);
        }
export function useGetChptrEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChptrEventsQuery, GetChptrEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChptrEventsQuery, GetChptrEventsQueryVariables>(GetChptrEventsDocument, options);
        }
export type GetChptrEventsQueryHookResult = ReturnType<typeof useGetChptrEventsQuery>;
export type GetChptrEventsLazyQueryHookResult = ReturnType<typeof useGetChptrEventsLazyQuery>;
export type GetChptrEventsSuspenseQueryHookResult = ReturnType<typeof useGetChptrEventsSuspenseQuery>;
export type GetChptrEventsQueryResult = Apollo.QueryResult<GetChptrEventsQuery, GetChptrEventsQueryVariables>;
export const GetContributionCommentsDocument = gql`
    query GetContributionComments($contributionId: String!, $commentsFirst: Int, $commentsAfter: String) {
  contribution(id: $contributionId) {
    __typename
    user {
      firstName
      lastName
    }
    caption
    id
    mediaType
    blurHash
    url
    commentsV2(first: $commentsFirst, after: $commentsAfter) {
      edges {
        cursor
        node {
          ...ContributionComment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    ${ContributionCommentFragmentDoc}`;

/**
 * __useGetContributionCommentsQuery__
 *
 * To run a query within a React component, call `useGetContributionCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContributionCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContributionCommentsQuery({
 *   variables: {
 *      contributionId: // value for 'contributionId'
 *      commentsFirst: // value for 'commentsFirst'
 *      commentsAfter: // value for 'commentsAfter'
 *   },
 * });
 */
export function useGetContributionCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetContributionCommentsQuery, GetContributionCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContributionCommentsQuery, GetContributionCommentsQueryVariables>(GetContributionCommentsDocument, options);
      }
export function useGetContributionCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContributionCommentsQuery, GetContributionCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContributionCommentsQuery, GetContributionCommentsQueryVariables>(GetContributionCommentsDocument, options);
        }
export function useGetContributionCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContributionCommentsQuery, GetContributionCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContributionCommentsQuery, GetContributionCommentsQueryVariables>(GetContributionCommentsDocument, options);
        }
export type GetContributionCommentsQueryHookResult = ReturnType<typeof useGetContributionCommentsQuery>;
export type GetContributionCommentsLazyQueryHookResult = ReturnType<typeof useGetContributionCommentsLazyQuery>;
export type GetContributionCommentsSuspenseQueryHookResult = ReturnType<typeof useGetContributionCommentsSuspenseQuery>;
export type GetContributionCommentsQueryResult = Apollo.QueryResult<GetContributionCommentsQuery, GetContributionCommentsQueryVariables>;
export const GetHomeDocument = gql`
    query GetHome($visibilities: [ChptrVisibility!], $placementId: String!, $isFeatured: Boolean, $chptrsFirst: Int, $contributionsFirst: Int, $requireContributions: Boolean, $query: String, $after: String, $ordersBy: ChptrOrderByInput, $eventsFirst: Int, $eventsStartAtAfter: String, $eventsQuery: String, $eventsAfter: String) {
  placement(id: $placementId) {
    name
    id
    chptrType
    configuration
    property {
      name
      currency
      addons {
        ...PurchaseProduct
      }
      products {
        ...PurchaseProduct
      }
      partner {
        name
      }
    }
    events: eventsV2(
      first: $eventsFirst
      startAtAfter: $eventsStartAtAfter
      query: $eventsQuery
      after: $eventsAfter
    ) {
      edges {
        cursor
        node {
          ...PlacementEvent
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
    featuredVideoContributions: featuredVideoContributionsV2 {
      chptr {
        id
        firstName
        lastName
        type
      }
      caption
      id
      mediaType
      thumbnailUrl
      url
    }
    chptrs: chptrsV2(
      visibilities: $visibilities
      isFeatured: $isFeatured
      first: $chptrsFirst
      requireContributions: $requireContributions
      query: $query
      after: $after
      ordersBy: $ordersBy
    ) {
      __typename
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          __typename
          type
          bornAt {
            day
            month
            year
          }
          firstName
          id
          lastName
          passedAt {
            day
            month
            year
          }
          events {
            location
            property {
              name
            }
          }
          pictureUrl
          webPictureUrl
          visibility
          location
          property {
            name
          }
          contributions(first: $contributionsFirst) {
            edges {
              node {
                __typename
                caption
                mediaType
                url
                thumbnailUrl
                blurHash
                user {
                  firstName
                  lastName
                  id
                }
              }
            }
            totalCount
          }
        }
      }
    }
  }
}
    ${PurchaseProductFragmentDoc}
${PlacementEventFragmentDoc}`;

/**
 * __useGetHomeQuery__
 *
 * To run a query within a React component, call `useGetHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeQuery({
 *   variables: {
 *      visibilities: // value for 'visibilities'
 *      placementId: // value for 'placementId'
 *      isFeatured: // value for 'isFeatured'
 *      chptrsFirst: // value for 'chptrsFirst'
 *      contributionsFirst: // value for 'contributionsFirst'
 *      requireContributions: // value for 'requireContributions'
 *      query: // value for 'query'
 *      after: // value for 'after'
 *      ordersBy: // value for 'ordersBy'
 *      eventsFirst: // value for 'eventsFirst'
 *      eventsStartAtAfter: // value for 'eventsStartAtAfter'
 *      eventsQuery: // value for 'eventsQuery'
 *      eventsAfter: // value for 'eventsAfter'
 *   },
 * });
 */
export function useGetHomeQuery(baseOptions: Apollo.QueryHookOptions<GetHomeQuery, GetHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeQuery, GetHomeQueryVariables>(GetHomeDocument, options);
      }
export function useGetHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeQuery, GetHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeQuery, GetHomeQueryVariables>(GetHomeDocument, options);
        }
export function useGetHomeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHomeQuery, GetHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomeQuery, GetHomeQueryVariables>(GetHomeDocument, options);
        }
export type GetHomeQueryHookResult = ReturnType<typeof useGetHomeQuery>;
export type GetHomeLazyQueryHookResult = ReturnType<typeof useGetHomeLazyQuery>;
export type GetHomeSuspenseQueryHookResult = ReturnType<typeof useGetHomeSuspenseQuery>;
export type GetHomeQueryResult = Apollo.QueryResult<GetHomeQuery, GetHomeQueryVariables>;
export const GetPlacementConfigurationDocument = gql`
    query GetPlacementConfiguration($placementId: String!) {
  placement(id: $placementId) {
    id
    chptrType
    configuration
  }
}
    `;

/**
 * __useGetPlacementConfigurationQuery__
 *
 * To run a query within a React component, call `useGetPlacementConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacementConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacementConfigurationQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *   },
 * });
 */
export function useGetPlacementConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GetPlacementConfigurationQuery, GetPlacementConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlacementConfigurationQuery, GetPlacementConfigurationQueryVariables>(GetPlacementConfigurationDocument, options);
      }
export function useGetPlacementConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlacementConfigurationQuery, GetPlacementConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlacementConfigurationQuery, GetPlacementConfigurationQueryVariables>(GetPlacementConfigurationDocument, options);
        }
export function useGetPlacementConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlacementConfigurationQuery, GetPlacementConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlacementConfigurationQuery, GetPlacementConfigurationQueryVariables>(GetPlacementConfigurationDocument, options);
        }
export type GetPlacementConfigurationQueryHookResult = ReturnType<typeof useGetPlacementConfigurationQuery>;
export type GetPlacementConfigurationLazyQueryHookResult = ReturnType<typeof useGetPlacementConfigurationLazyQuery>;
export type GetPlacementConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetPlacementConfigurationSuspenseQuery>;
export type GetPlacementConfigurationQueryResult = Apollo.QueryResult<GetPlacementConfigurationQuery, GetPlacementConfigurationQueryVariables>;
export const GetPlacementEventsDocument = gql`
    query GetPlacementEvents($placementId: String!, $eventsFirst: Int, $eventsStartAtAfter: String, $eventsQuery: String, $eventsAfter: String, $eventsOrdersBy: EventOrderByInput) {
  placement(id: $placementId) {
    __typename
    id
    events: eventsV2(
      first: $eventsFirst
      startAtAfter: $eventsStartAtAfter
      query: $eventsQuery
      after: $eventsAfter
      ordersBy: $eventsOrdersBy
    ) {
      edges {
        cursor
        node {
          ...PlacementEvent
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    ${PlacementEventFragmentDoc}`;

/**
 * __useGetPlacementEventsQuery__
 *
 * To run a query within a React component, call `useGetPlacementEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacementEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacementEventsQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *      eventsFirst: // value for 'eventsFirst'
 *      eventsStartAtAfter: // value for 'eventsStartAtAfter'
 *      eventsQuery: // value for 'eventsQuery'
 *      eventsAfter: // value for 'eventsAfter'
 *      eventsOrdersBy: // value for 'eventsOrdersBy'
 *   },
 * });
 */
export function useGetPlacementEventsQuery(baseOptions: Apollo.QueryHookOptions<GetPlacementEventsQuery, GetPlacementEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlacementEventsQuery, GetPlacementEventsQueryVariables>(GetPlacementEventsDocument, options);
      }
export function useGetPlacementEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlacementEventsQuery, GetPlacementEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlacementEventsQuery, GetPlacementEventsQueryVariables>(GetPlacementEventsDocument, options);
        }
export function useGetPlacementEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlacementEventsQuery, GetPlacementEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlacementEventsQuery, GetPlacementEventsQueryVariables>(GetPlacementEventsDocument, options);
        }
export type GetPlacementEventsQueryHookResult = ReturnType<typeof useGetPlacementEventsQuery>;
export type GetPlacementEventsLazyQueryHookResult = ReturnType<typeof useGetPlacementEventsLazyQuery>;
export type GetPlacementEventsSuspenseQueryHookResult = ReturnType<typeof useGetPlacementEventsSuspenseQuery>;
export type GetPlacementEventsQueryResult = Apollo.QueryResult<GetPlacementEventsQuery, GetPlacementEventsQueryVariables>;
export const GetPlacementFeaturedVideosDocument = gql`
    query getPlacementFeaturedVideos($placementId: String!) {
  placement(id: $placementId) {
    id
    featuredVideoContributions: featuredVideoContributionsV2 {
      chptr {
        id
        firstName
        lastName
        type
      }
      caption
      id
      mediaType
      thumbnailUrl
      url
    }
  }
}
    `;

/**
 * __useGetPlacementFeaturedVideosQuery__
 *
 * To run a query within a React component, call `useGetPlacementFeaturedVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacementFeaturedVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacementFeaturedVideosQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *   },
 * });
 */
export function useGetPlacementFeaturedVideosQuery(baseOptions: Apollo.QueryHookOptions<GetPlacementFeaturedVideosQuery, GetPlacementFeaturedVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlacementFeaturedVideosQuery, GetPlacementFeaturedVideosQueryVariables>(GetPlacementFeaturedVideosDocument, options);
      }
export function useGetPlacementFeaturedVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlacementFeaturedVideosQuery, GetPlacementFeaturedVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlacementFeaturedVideosQuery, GetPlacementFeaturedVideosQueryVariables>(GetPlacementFeaturedVideosDocument, options);
        }
export function useGetPlacementFeaturedVideosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlacementFeaturedVideosQuery, GetPlacementFeaturedVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlacementFeaturedVideosQuery, GetPlacementFeaturedVideosQueryVariables>(GetPlacementFeaturedVideosDocument, options);
        }
export type GetPlacementFeaturedVideosQueryHookResult = ReturnType<typeof useGetPlacementFeaturedVideosQuery>;
export type GetPlacementFeaturedVideosLazyQueryHookResult = ReturnType<typeof useGetPlacementFeaturedVideosLazyQuery>;
export type GetPlacementFeaturedVideosSuspenseQueryHookResult = ReturnType<typeof useGetPlacementFeaturedVideosSuspenseQuery>;
export type GetPlacementFeaturedVideosQueryResult = Apollo.QueryResult<GetPlacementFeaturedVideosQuery, GetPlacementFeaturedVideosQueryVariables>;
export const GetPlacementPartnerTermsDocument = gql`
    query GetPlacementPartnerTerms($placementId: String!) {
  placement(id: $placementId) {
    partner {
      id
    }
  }
}
    `;

/**
 * __useGetPlacementPartnerTermsQuery__
 *
 * To run a query within a React component, call `useGetPlacementPartnerTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacementPartnerTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacementPartnerTermsQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *   },
 * });
 */
export function useGetPlacementPartnerTermsQuery(baseOptions: Apollo.QueryHookOptions<GetPlacementPartnerTermsQuery, GetPlacementPartnerTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlacementPartnerTermsQuery, GetPlacementPartnerTermsQueryVariables>(GetPlacementPartnerTermsDocument, options);
      }
export function useGetPlacementPartnerTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlacementPartnerTermsQuery, GetPlacementPartnerTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlacementPartnerTermsQuery, GetPlacementPartnerTermsQueryVariables>(GetPlacementPartnerTermsDocument, options);
        }
export function useGetPlacementPartnerTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlacementPartnerTermsQuery, GetPlacementPartnerTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlacementPartnerTermsQuery, GetPlacementPartnerTermsQueryVariables>(GetPlacementPartnerTermsDocument, options);
        }
export type GetPlacementPartnerTermsQueryHookResult = ReturnType<typeof useGetPlacementPartnerTermsQuery>;
export type GetPlacementPartnerTermsLazyQueryHookResult = ReturnType<typeof useGetPlacementPartnerTermsLazyQuery>;
export type GetPlacementPartnerTermsSuspenseQueryHookResult = ReturnType<typeof useGetPlacementPartnerTermsSuspenseQuery>;
export type GetPlacementPartnerTermsQueryResult = Apollo.QueryResult<GetPlacementPartnerTermsQuery, GetPlacementPartnerTermsQueryVariables>;
export const GetRecentChptrsDocument = gql`
    query GetRecentChptrs($visibilities: [ChptrVisibility!], $placementId: String!, $isFeatured: Boolean, $chptrsFirst: Int, $contributionsFirst: Int, $requireContributions: Boolean, $query: String, $after: String, $ordersBy: ChptrOrderByInput) {
  placement(id: $placementId) {
    chptrs: chptrsV2(
      visibilities: $visibilities
      isFeatured: $isFeatured
      first: $chptrsFirst
      requireContributions: $requireContributions
      query: $query
      after: $after
      ordersBy: $ordersBy
    ) {
      __typename
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          __typename
          type
          bornAt {
            day
            month
            year
          }
          firstName
          id
          lastName
          passedAt {
            day
            month
            year
          }
          pictureUrl
          webPictureUrl
          visibility
          contributions(first: $contributionsFirst) {
            edges {
              node {
                __typename
                caption
                mediaType
                url
                thumbnailUrl
                blurHash
                user {
                  firstName
                  lastName
                  id
                }
              }
            }
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecentChptrsQuery__
 *
 * To run a query within a React component, call `useGetRecentChptrsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentChptrsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentChptrsQuery({
 *   variables: {
 *      visibilities: // value for 'visibilities'
 *      placementId: // value for 'placementId'
 *      isFeatured: // value for 'isFeatured'
 *      chptrsFirst: // value for 'chptrsFirst'
 *      contributionsFirst: // value for 'contributionsFirst'
 *      requireContributions: // value for 'requireContributions'
 *      query: // value for 'query'
 *      after: // value for 'after'
 *      ordersBy: // value for 'ordersBy'
 *   },
 * });
 */
export function useGetRecentChptrsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentChptrsQuery, GetRecentChptrsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentChptrsQuery, GetRecentChptrsQueryVariables>(GetRecentChptrsDocument, options);
      }
export function useGetRecentChptrsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentChptrsQuery, GetRecentChptrsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentChptrsQuery, GetRecentChptrsQueryVariables>(GetRecentChptrsDocument, options);
        }
export function useGetRecentChptrsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentChptrsQuery, GetRecentChptrsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentChptrsQuery, GetRecentChptrsQueryVariables>(GetRecentChptrsDocument, options);
        }
export type GetRecentChptrsQueryHookResult = ReturnType<typeof useGetRecentChptrsQuery>;
export type GetRecentChptrsLazyQueryHookResult = ReturnType<typeof useGetRecentChptrsLazyQuery>;
export type GetRecentChptrsSuspenseQueryHookResult = ReturnType<typeof useGetRecentChptrsSuspenseQuery>;
export type GetRecentChptrsQueryResult = Apollo.QueryResult<GetRecentChptrsQuery, GetRecentChptrsQueryVariables>;
export const PlacementDocument = gql`
    query Placement($placementId: String!) {
  placement(id: $placementId) {
    name
    id
    chptrType
    configuration
    property {
      name
      currency
      addons {
        ...PurchaseProduct
      }
      products {
        ...PurchaseProduct
      }
      partner {
        name
      }
    }
  }
}
    ${PurchaseProductFragmentDoc}`;

/**
 * __usePlacementQuery__
 *
 * To run a query within a React component, call `usePlacementQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementQuery({
 *   variables: {
 *      placementId: // value for 'placementId'
 *   },
 * });
 */
export function usePlacementQuery(baseOptions: Apollo.QueryHookOptions<PlacementQuery, PlacementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementQuery, PlacementQueryVariables>(PlacementDocument, options);
      }
export function usePlacementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementQuery, PlacementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementQuery, PlacementQueryVariables>(PlacementDocument, options);
        }
export function usePlacementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlacementQuery, PlacementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlacementQuery, PlacementQueryVariables>(PlacementDocument, options);
        }
export type PlacementQueryHookResult = ReturnType<typeof usePlacementQuery>;
export type PlacementLazyQueryHookResult = ReturnType<typeof usePlacementLazyQuery>;
export type PlacementSuspenseQueryHookResult = ReturnType<typeof usePlacementSuspenseQuery>;
export type PlacementQueryResult = Apollo.QueryResult<PlacementQuery, PlacementQueryVariables>;
export const UserDocument = gql`
    query User($userId: String!) {
  user(id: $userId) {
    __typename
    email
    firstName
    lastName
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;